export default "/wp-content/themes/15015/assets/dist/fonts/vendor/slick-carousel/slick/slick.eot?a4e97f5a2a64f0ab132323fbeb33ae29";